import { useQuery } from '@tanstack/react-query'

import ConversationQueryKeyGenerator from './ConversationQueryKeyGenerator'

import { getConversationOnyxChatStatus } from '@/api/query'

interface UseCheckOnyxChatStatusProps {
  conversationId?: string
  messageId?: string
  shouldPoll?: boolean
  enabled?: boolean
}

export const useCheckOnyxChatStatus = ({
  conversationId,
  messageId,
  shouldPoll = false,
  enabled = true,
}: UseCheckOnyxChatStatusProps) => {
  return useQuery({
    queryKey: ConversationQueryKeyGenerator.check_onyx_chat_status(conversationId, messageId),
    queryFn: getConversationOnyxChatStatus(conversationId, messageId),
    refetchInterval: shouldPoll ? 5000 : false,
    enabled: !!conversationId && !!messageId && enabled,
  })
}
